


import countryIndex from '@/views/study/country/index'
// 国医名师
const course1Routes = Array.from({ length: 16 }, (_, i) => ({
  path: `country/course1/index${i + 1}`,
  name: `country/course1/Index${i + 1}`,
  component: () => import(`@/views/study/country/course1/index${i + 1}.vue`)
}))
// 课程超市
const course2Routes = Array.from({ length: 19 }, (_, i) => ({
  path: `country/course2/index${i + 1}`,
  name: `country/course2/Index${i + 1}`,
  component: () => import(`@/views/study/country/course2/index${i + 1}.vue`)
}))
// 线上学习
const course3Routes = Array.from({ length: 15 }, (_, i) => ({
  path: `country/course3/index${i + 1}`,
  name: `country/course3/Index${i + 1}`,
  component: () => import(`@/views/study/country/course3/index${i + 1}.vue`)
}))
// 云课堂
const course4Routes = Array.from({ length: 19 }, (_, i) => ({
  path: `country/course4/index${i + 1}`,
  name: `country/course4/Index${i + 1}`,
  component: () => import(`@/views/study/country/course4/index${i + 1}.vue`)
}))



export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'country/index',
        name: 'countryIndex',
        component: countryIndex
      },
    // 国医名师，开始
    ...course1Routes,
    // 国医名师，结束

    // 课程超市，开始
    ...course2Routes,
    // 课程超市，结束

    // 线上学习，开始
    ...course3Routes,
    // 线上学习，结束

    // 云课堂，开始
    ...course4Routes,
    // 云课堂，结束

  ],
};
